import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { SettingsPage as SettingsPageComponent, useTheme } from '@deckspace/ui';
import { APP_VERSION } from '@deckspace/types';
import type { ConnectionStatus } from '@deckspace/types';
import { useUserPreferences, useAuth } from '@deckspace/client';

// TODO: Wire to SSE connection state instead of hardcoding
const connectionStatus: ConnectionStatus = {
  state: 'connected',
};

export function Settings() {
  const navigate = useNavigate();
  const { colorScheme, setColorScheme } = useTheme();
  const { user, signOut } = useAuth();
  const { updatePreferences } = useUserPreferences(user ? { userId: user.id } : null);

  const handleClose = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const handleColorSchemeChange = useCallback(
    (scheme: 'dark' | 'light') => {
      setColorScheme(scheme);
      updatePreferences({ colorScheme: scheme });
    },
    [setColorScheme, updatePreferences]
  );

  return (
    <SettingsPageComponent
      colorScheme={colorScheme}
      onColorSchemeChange={handleColorSchemeChange}
      connectionStatus={connectionStatus}
      version={APP_VERSION}
      onClose={handleClose}
      userEmail={user?.email ?? null}
      onSignOut={signOut}
    />
  );
}
